import { SeverityNumber, logs } from "@opentelemetry/api-logs";

import { errorAttributes } from "@/src/utils/observability/error-attributes";
import { LogAttributes, LogEvent } from "@/src/utils/observability/log-types";

export const emitLogRecord = (
  loggerName: string,
  severityNumber: SeverityNumber,
  logEvent: LogEvent,
): void => {
  const { event, category, message, attributes, error } = logEvent;

  const mergedAttributes: LogAttributes = {
    "event.name": event, // Duplicates the top-level eventName, as it doesn't show in Grafana
    "log.category": category,
    ...errorAttributes(error),
    ...attributes,
  };

  // Undefined values would serialize as empty OTLP attribute values
  const definedAttributes: LogAttributes = Object.fromEntries(
    Object.entries(mergedAttributes).filter(([, value]) => value !== undefined),
  );

  const exceptionType = definedAttributes["exception.type"];
  const body =
    message ??
    (typeof exceptionType === "string" ? `${event}: ${exceptionType}` : event);

  logs.getLogger(loggerName, process.env.APP_VERSION).emit({
    eventName: event,
    severityNumber,
    severityText: SeverityNumber[severityNumber],
    body,
    attributes: definedAttributes,
  });
};
